import { Calendar, GraduationCap, Building2, CheckCircle } from "lucide-react";

const badges = [
  { value: "12+", label: "Years", icon: Calendar },
  { value: "50+", label: "Schools", icon: GraduationCap },
  { value: "100+", label: "Corporates", icon: Building2 },
  { value: "", label: "Color Consistency Guaranteed", icon: CheckCircle },
];

export default function TrustBadges() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 py-8">
      {badges.map((badge) => {
        const Icon = badge.icon;
        return (
          <div key={badge.label} className="flex items-center gap-3">
            <Icon className="h-8 w-8 text-[#e85a1f]" strokeWidth={1.5} />
            <div className="text-left">
              {badge.value && (
                <span className="block text-2xl font-bold tracking-tight text-gray-900">
                  {badge.value}
                </span>
              )}
              <span
                className={`block text-sm text-gray-500 ${
                  badge.value ? "" : "font-semibold text-gray-900"
                }`}
              >
                {badge.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}